import { CountryUIConfigName } from './country-ui-config/constants';

export enum SharedCountryConfigNames {
  TaxIdRequired = 'TaxIdRequired',
  AddressValidation = 'AddressValidation',
  ManualUSPSPickup = 'ManualUSPSPickup',
  ShowInsights = 'ShowInsights',
  ShowWeeklyDigestEmail = 'ShowWeeklyDigestEmail',
  ShowTemplateOptionCards = 'ShowTemplateOptionCards',
  TopMarketplaces = 'TopMarketplaces',
  ShippingStrategy = 'ShippingStrategy',
  TaxesIncludedInOrdersTotal = 'TaxesIncludedInOrdersTotal',
  UseSellerDefaultUnitsOfMeasureOnCsvOrderImport = 'UseSellerDefaultUnitsOfMeasureOnCsvOrderImport',
  RateBrowserConfiguration = 'RateBrowserConfiguration',
  ApplyTaxCharges = 'ApplyTaxCharges',
}

export type CountryConfigNames = SharedCountryConfigNames | CountryUIConfigName;
export const CountryConfigNames = { ...SharedCountryConfigNames, ...CountryUIConfigName };
